import React, { useEffect, useState } from "react";
import TopLogo from "../image/latin_logo.png";
import { Link, useNavigate } from "react-router-dom";
import DepartmentNavbar from "./DepartmentNavbar";
import { useDispatch, useSelector } from "react-redux";
import { allapiAction } from "../Redux/common/action";
import { toast } from "react-toastify";
import { URL } from "../Redux/common/url";


import { FloatingWhatsApp } from 'react-floating-whatsapp';

export default function TopHeader() {
  const dispatch = useDispatch();
  const [value, setValue] = useState("");
  const [valuevendor, setValuevendor] = useState("");
  const [valuesetUserDeatils, setUserDeatils] = useState({});
  const router = useNavigate();

  const [isSticky, setIsSticky] = useState(false);
  const [searchtype, setsearchtype] = useState("");
  const [searchdata, setsearchdata] = useState("");
  const [userselete, setuserselete] = useState(null);

  // --- Sticky Scroll Logic ---
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // --- Auth & Token Logic ---
  useEffect(() => {
    if (typeof window !== "undefined") {
      setValue(localStorage.getItem("access_token"));
      setValuevendor(localStorage.getItem("access_token_vendor"));
      const userDetails = localStorage.getItem("access_user");
      setUserDeatils(userDetails ? JSON.parse(userDetails) : {});
    }
  }, []);

  const tokenhave = value || valuevendor ? true : false;
  const get_all_cart_itme = useSelector((state) => state?.allapi?.get_all_cart_itme || []);
  const get_user_profile = useSelector((state) => state?.allapi?.get_user_profile || {});

  const totalSubtotalPrice = get_all_cart_itme.reduce((total, obj) => {
    return total + (obj.subtotalprice || 0);
  }, 0);

  let arrss = [];
  if (typeof window !== "undefined") {
    const blogids = localStorage.getItem("cart_product");
    const arr = blogids ? JSON.parse(blogids) : [];
    arrss = tokenhave ? get_all_cart_itme : arr;
  }

  useEffect(() => {
    dispatch(allapiAction.getCategory({}));
  }, [dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (tokenhave) {
        dispatch(allapiAction.getcartitme({ data: arrss }));
      } else if (arrss?.length > 0) {
        dispatch(allapiAction.getcartProduct({ data: arrss }));
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [tokenhave, dispatch]);

  // --- Functions ---
  const hendlesearchProduct = (e) => {
    setsearchdata(e.target.value);
    if (e.key === "Enter") {
      e.preventDefault();
      const locParam = userselete ? `&location=${userselete._id}` : "";
      const path = searchtype === "listing" ? "/listings" : "/products";
      router(`${path}?search=${e.target.value}${locParam}`);
    }
  };

  const hensletosearch = (e) => {
    e.preventDefault();
    const locParam = userselete ? `&location=${userselete._id}` : "";
    const path = searchtype === "listing" ? "/listings" : "/products";
    router(`${path}?search=${searchdata}${locParam}`);
  };

  function removeCartItem(e, color, size) {
    dispatch(allapiAction.removeCartItem({
      product_id: e,
      color: color,
      size: size,
    }));
  }

  return (
    <>
      <header className={`site-top-header py-sm-0 py-2 float slow-glow bg-topheader ${isSticky ? 'header-sticky-active' : ''}`}>
        <div className="container-fluid d-flex align-items-center justify-content-between">
          
          {/* LEFT: Logo */}
          <div className="d-flex align-items-center gap-3 left-group">
            <Link to="/" className="top-logo-link d-flex align-items-center shimmer-text">
              <img src={TopLogo} alt="logo" className="top-logo-img coin-spin" />
            </Link>
          </div>

          {/* CENTER: Search */}
          <div className="header-search w-50 d-none d-lg-flex align-items-center pulse-fast">
            <input
              className="search-input rounded-pill"
              type="text"
              placeholder='Search "Bracelets"'
              onChange={hendlesearchProduct}
              onKeyDown={hendlesearchProduct}
            />
            <button className="search-btn wobble" onClick={hensletosearch} type="button">
              <i className="fas fa-search"></i>
            </button>
          </div>

          {/* RIGHT: Icons / Auth */}
          <div className="gap-3 right-group d-flex align-items-center">
            <Link to="/products" className="icon-btn shimmer-text">
              <i className="fas fa-store d-flex wobble justify-content-center"></i>
              <small className="text-center d-none d-sm-block">STORE</small>
            </Link>

            {!tokenhave && (
              <>
                <Link to="/login" className="icon-btn shimmer-text">
                  <i className="fas fa-sign-in-alt d-flex wobble justify-content-center"></i>
                  <small className="text-center text-nowrap d-none d-sm-block">SIGN IN</small>
                </Link>
                <Link to="/register" className="icon-btn shimmer-text">
                  <i className="fas fa-user-plus d-flex wobble justify-content-center"></i>
                  <small className="text-center d-none d-sm-block">REGISTER</small>
                </Link>
              </>
            )}

            {value && (
              <Link to="/accounts" className="icon-btn shimmer-text">
                <i className="fas fa-user d-flex wobble justify-content-center"></i>
                <small className="text-center d-none d-sm-block">{valuesetUserDeatils?.fullName}</small>
              </Link>
            )}

            {valuevendor && (
              <Link to="/seller" className="icon-btn shimmer-text">
                <i className="fas fa-briefcase d-flex wobble justify-content-center"></i>
                <small className="text-center d-none d-sm-block">{valuesetUserDeatils?.fullName}</small>
              </Link>
            )}

            {/* CART SECTION */}
            <div className="ps-cart--mini">
              <Link to="/cart" className="icon-btn shimmer-text mt-2">
                <div style={{ position: "relative" }}>
                  <i className="fas fa-shopping-cart d-flex wobble justify-content-center"></i>
                  {get_all_cart_itme?.length > 0 && (
                    <span className="cart-badge-ui">
                      {get_all_cart_itme.length}
                    </span>
                  )}
                </div>
                <small className="text-center d-none d-sm-block">CART</small>
              </Link>

              {/* Cart Dropdown Content */}
              <div className="ps-cart__content">
                <div className="ps-cart__items">
                  {get_all_cart_itme?.map((data, i) => (
                    <div className="ps-product--cart-mobile" key={i}>
                      <div className="ps-product__thumbnail">
                        <Link to={"/product/" + data?.pro_sulg}>
                          <img src={URL?.API_BASE_URL + data?.featureImage} alt="" />
                        </Link>
                      </div>
                      <div className="ps-product__content">
                        <Link to={"/product/" + data?.pro_sulg}>{data?.title}</Link>
                        <br />
                        <small>{data?.item} x ₹{data?.afterdiscountprice}</small>
                        <button
                          className="btn btn-danger btn-sm ms-2"
                          style={{fontSize: '10px', padding: '2px 5px'}}
                          onClick={() => removeCartItem(data?.productId?._id, data?.productcolorId?._id, data?._id)}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="ps-cart__footer">
                  <h3>Sub Total: ₹{totalSubtotalPrice}</h3>
                  <figure>
                    {tokenhave ? (
                      <Link className="ps-btn" to="/cart">View Cart</Link>
                    ) : (
                      <button className="ps-btn" onClick={() => { router("/login"); toast.error("Login first!"); }}>
                        View Cart
                      </button>
                    )}
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
{/* 2. Floating WhatsApp Component Use Karein */}
      <FloatingWhatsApp 
        phoneNumber="919352212342" // <-- Apna number 91 ke sath yahan daalein
        accountName="Toshni jewellers" // <-- Chat window mein jo naam dikhega
        allowEsc={true}
        allowClickAway={true}
        notification={true}
        notificationDelay={30}
        statusMessage="Online"
        chatMessage="Namaste! ✨ Welcome to Toshni Jewellers. If you have any questions about our collection or pricing, feel free to ask!" // <-- Auto welcome message
        placeholder="Type a message..."
        avatar={TopLogo} // <-- Chat window mein logo dikhane ke liye
        darkMode={false}
      />
      {/* Spacer taaki content header ke niche na chhup jaye jab sticky ho */}
      <div style={{ paddingTop: isSticky ? '80px' : '0px' }}>
        <DepartmentNavbar />
      </div>
    </>
  );
}